import Const from 'constants';
import SuffixMarker from 'services/simplex/suffix-marker';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_COMPETITION_STACK_SUFFIX;

const CompetitionStackMarker = {
    suffix,
    ...SuffixMarker,
};

export default CompetitionStackMarker;
